import { render, staticRenderFns } from "./CryptoUnsupportedNotice.vue?vue&type=template&id=3325fadc&scoped=true"
import script from "./CryptoUnsupportedNotice.vue?vue&type=script&lang=js"
export * from "./CryptoUnsupportedNotice.vue?vue&type=script&lang=js"
import style0 from "./CryptoUnsupportedNotice.vue?vue&type=style&index=0&id=3325fadc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3325fadc",
  null
  
)

export default component.exports